import React from "react";
import pdfFile from "../pdfs/Tipkit-ValetGuide-spanish.pdf";
import PdfViewer from "../comman/PdfViewer";

const ValentGuideSpanish = () => {
    return <PdfViewer pdfFile={pdfFile} />;
};

export default ValentGuideSpanish;
